/** Base Fetch Actions */
export const FETCH_WORKFLOW_WEBHOOKS_ERROR = `FETCH_WORKFLOW_WEBHOOKS_ERROR`;
export const FETCH_WORKFLOW_WEBHOOKS_REQUEST = `FETCH_WORKFLOW_WEBHOOKS_REQUEST`;
export const FETCH_WORKFLOW_WEBHOOKS_RESPONSE = `FETCH_WORKFLOW_WEBHOOKS_RESPONSE`;

export const UPDATE_WORKFLOW_WEBHOOK_ERROR = `UPDATE_WORKFLOW_WEBHOOK_ERROR`;
export const UPDATE_WORKFLOW_WEBHOOK_REQUEST = `UPDATE_WORKFLOW_WEBHOOK_REQUEST`;
export const UPDATE_WORKFLOW_WEBHOOK_RESPONSE = `UPDATE_WORKFLOW_WEBHOOK_RESPONSE`;

export const CREATE_WORKFLOW_WEBHOOK_ERROR = `CREATE_WORKFLOW_WEBHOOK_ERROR`;
export const CREATE_WORKFLOW_WEBHOOK_REQUEST = `CREATE_WORKFLOW_WEBHOOK_REQUEST`;

export const DELETE_WORKFLOW_WEBHOOK_ERROR = `DELETE_WORKFLOW_WEBHOOK_ERROR`;
export const DELETE_WORKFLOW_WEBHOOK_REQUEST = `DELETE_WORKFLOW_WEBHOOK_REQUEST`;
export const DELETE_WORKFLOW_WEBHOOK_RESPONSE = `DELETE_WORKFLOW_WEBHOOK_RESPONSE`;
